// "You're at the station" (opt-in, iOS): opening the app soon after that notice
// lands on the board for the station, with the other one as the destination.
// Also keeps the watched places in step with home and work.
import { requestBoard } from './board-request.js';

let arrivalWatching = false;

/** `ready` as in `openRoute`: the arrival is consumed only once stations can be read. */
export async function openArrival({ router, ready = Promise.resolve() }) {
  await ready;
  const { atStation, syncArrival, takeArrival } = await import('./at-station.js');
  if (!atStation.value.enabled) return;
  const [{ favourites, places, rules }, { stationById }, { mergeTrips }, { watch }] = await Promise.all([
    import('./app-state.js'),
    import('./network.js'),
    import('./trips.js'),
    import('vue'),
  ]);
  const ctx = () => ({ places: places.value, stationById, trips: mergeTrips(favourites.value, rules.value) });
  await syncArrival(ctx());
  // Saving, removing or changing a trip changes what is watched.
  if (!arrivalWatching) {
    arrivalWatching = true;
    watch([favourites, rules, places], () => syncArrival(ctx()), { deep: true });
  }
  const got = await takeArrival();
  const station = got ? stationById(got.stopId) : null;
  if (!station) return;
  requestBoard(station, { destStopId: got.toStopId || null });
  if (got.follow) {
    const { requestFollowAt } = await import('./board-request.js');
    requestFollowAt(station.stopId, got.follow);
  }
  router.push('/tabs/departures').catch(() => { /* already on it — the board watches */ });
}

